import {createSelector} from 'reselect';
import device from '../../../tracking/device';
import {isInApp} from '../../../utils/user-agent';
import {getSelectedDeliveryOptionIDList} from '../../DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import * as DeviceSelectors from '../../DeviceSelectors';
import {getSettings} from '../../selectors';

export const getWeChatPayShouldHide = createSelector(
  [getSettings, DeviceSelectors.isMobile, getSelectedDeliveryOptionIDList],
  (settings, isMobile, selectedDeliveryOptionIDList) => {
    const isWeChatAppUser = device.getBrowserData().family === 'WeChat';
    const isValidAppUser = isWeChatAppUser && parseFloat(device.getBrowserData().version) >= 5;
    
    // We can't support hosted payment methods via our apps so should hide
    if (isInApp()) {
      return true;
    }
    
    if (isWeChatAppUser) {
      return !(isValidAppUser && settings.wechatpay_app_flow_enabled);
    }
    
    if (isMobile) {
      if (selectedDeliveryOptionIDList?.length > 0 && selectedDeliveryOptionIDList.includes(58)) {
        return !settings.enable_wechat_h5_with_smk;
      }
      
      return !settings.enable_wechat_h5;
    }
      
    return false;
  },
);
